import { ApplicationConfig, inject, LOCALE_ID, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { appRoutes } from './app.routes';
import { API_CONFIG, environment, LocalStorageKeys, TranslationService } from '@concretecode/data';
import { Amplify } from 'aws-amplify';
import enTranslations from '../i18n/en.json';
import deTranslations from '../i18n/de.json';
import frTranslations from '../i18n/fr.json';
import itTranslations from '../i18n/it.json';
import { subdomainRedirectInitializer } from './core/initializer/subdomain-redirect.initializer';
import { langQueryParamInitializer } from '@concretecode/data';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch()),
    { provide: LOCALE_ID, useFactory: () => localStorage?.getItem(LocalStorageKeys.preferredLanguage) || navigator?.language || 'de-CH' },
    { provide: API_CONFIG, useValue: environment.apiConfig },
    provideAppInitializer(langQueryParamInitializer()),
    provideAppInitializer(() => {
      const translationService = inject(TranslationService);
      translationService.registerTranslations('en', enTranslations);
      translationService.registerTranslations('de', deTranslations);
      translationService.registerTranslations('fr', frTranslations);
      translationService.registerTranslations('it', itTranslations);
      translationService.initialize();
    }),
    provideAppInitializer(async () => {
      Amplify.configure(environment.apiConfig.amplifyConfig);
    }),
    provideAppInitializer(subdomainRedirectInitializer()),
  ],
};
